import * as React from 'react';
import { ImageWithInfo } from '../empracoTypes';
import { Swiper, SwiperSlide } from 'swiper/react';
import { NavigationButton } from './logotypes/logotypesNavigation';
import { FaIcon } from '../generic/icon';
import { Direction } from '../util/util';

interface RawPageSlideshowProps {
  items: ImageWithInfo[];
}

function RawPageItem(item: ImageWithInfo) {
  return(
    <a className='empori-raw-page-item'
      href={item.pageLink}
      title={item.title}>
      <div className='empori-raw-page-item-title'>
        <h2>{item.title}</h2>
      </div>
      <div className='empori-raw-page-item-image lazy'
        style={item.imgUrl ? { backgroundImage: `url(${item.imgUrl})` } : {}}
        title={item.imgAlt}>
        {!item.imgUrl && <FaIcon clsName='fa-regular fa-image' />}
      </div>
    </a>
  );
}

export default function RawPageSlideshow({ items }: RawPageSlideshowProps) {
  if (!items || items && items.length < 1) {
    return null;
  }

  const breakpoints = {
    800: { // 800px or more
      slidesPerView: 3
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 20
    }
  };

  let activeItems = items;

  // If there's only two items in the array, add an extra two sets to make the loop work properly
  // since we're using three slides per view in this case.
  // Seems like it's a Swiper bug: https://github.com/nolimits4web/swiper/issues/2542
  if (items.length >= 2 || items.length <= 4) {
    activeItems = activeItems.concat(items).concat(items);
  }

  return(
    <Swiper
      slidesPerView={3}
      spaceBetween={0}
      breakpoints={breakpoints}
      loop
      autoHeight
      lazy>
      {activeItems.map((item, index) => <SwiperSlide key={index}>{RawPageItem(item)}</SwiperSlide>)}
      <NavigationButton direction={Direction.prev} absolute />
      <NavigationButton direction={Direction.next} absolute />
    </Swiper>
  );
}